import React, { memo } from 'react';
export const Footer = () => {
  return <footer className="bg-navy-900 text-cream-200/60 py-12 border-t border-gold-500/10" data-id="element-83">
      <div className="container mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-84">
        <div className="text-center md:text-left" data-id="element-85">
          <div className="font-serif text-xl font-bold text-cream mb-2 flex items-center justify-center md:justify-start gap-2" data-id="element-86">
            <span className="text-gold-500 text-sm" data-id="element-87">✦</span>
            LA MEMORIA DEL ALMA™
          </div>
          <p className="text-sm" data-id="element-88">Protocolo Clínico Holístico</p>
        </div>

        <div className="text-center md:text-right text-sm space-y-2" data-id="element-89">
          <p data-id="element-90">
            Contacto:{' '}
            <a href="mailto:palabra.viva.soporte@gmail.com" className="hover:text-gold-400 transition-colors" data-id="element-91">
              palabra.viva.soporte@gmail.com
            </a>
          </p>
          <p data-id="element-92">
            Instagram:{' '}
            <a href="https://instagram.com/palabraviva.ebook" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-93">
              @palabraviva.ebook
            </a>
          </p>
        </div>
      </div>

      <div className="container mx-auto px-6 mt-8 pt-8 border-t border-white/5 text-center text-xs" data-id="element-94">
        <p data-id="element-95">© LaMemoriadelAlma™ 2026 — Todos los derechos reservados.</p>
      </div>
    </footer>;
};